import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '../Common/styles/Charts.css';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { menus } from './Common/Consts/sidebar';
import { AIH } from './AIH/AIH';
import { Perfil } from './Perfil/Perfil';
import { Hospitalization } from './Hospitalization/Hospitalization';
import { UTI } from './UTI/UTI';
import { Procedures } from './Procedures/Procedures';
import { Discharge } from './Discharge/Discharge';
import { Revenue } from './Revenue/Revenue';
import { HomeNav } from '../Common/Home/HomeNav';

function DashBoardSihSus() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} />
            <div className="dashboards-page">
                <HomeNav menus={menus} />
                <Routes>
                    <Route
                        path="/"
                         element={<Navigate to="aih" replace />}
                    />
                    <Route path="/aih/*" element={<AIH />} />
                    <Route path="/perfil/*" element={<Perfil />} />
                    <Route
                        path="/hospitalization/*"
                        element={<Hospitalization />}
                    />
                    <Route path="/uti/*" element={<UTI />} />
                    <Route path="/procedures/*" element={<Procedures />} />
                    <Route path="/discharge/*" element={<Discharge />} />

                    <Route path="/revenue/*" element={<Revenue />} />
                </Routes>
            </div>
        </QueryClientProvider>
    );
}

export default DashBoardSihSus;
